import React from 'react'

const Ap = () => {
    return (
        <div className='container'>
            <h1>Program to print Arithmetic Progression series</h1>
            <p>Given first term (a), common difference (d) and a integer n of the Arithmetic Progression series, the task is 
                to print the series. </p>
                <p><strong>Examples : </strong></p>
                <div className='output'>
                Input : a = 5, d = 2, n = 10 <br />
Output : 5 7 9 11 13 15 17 19 21 23 <br />
                </div>
                <p><strong>Approach : </strong></p>
                <blockquote>
                <p>We know the Arithmetic Progression series is like = 2, 5, 8, 11, 14 …. …&nbsp;<br/>
                In this series 2 is the stating term of the series .&nbsp;<br/>
                Common difference = 5 – 2 = 3 (Difference common in the series).&nbsp;<br/>
                so we can write the series as :&nbsp;<br/>
                t1 = a1&nbsp;<br/>
                t2 = a1 + (2-1) * d&nbsp;<br/>
                t3 = a1 + (3-1) * d&nbsp;<br/>
                .&nbsp;<br/>
                .&nbsp;<br/>
                .&nbsp;<br/>
                tn = a1 + (n-1) * d&nbsp;<br/>
                &nbsp;</p></blockquote>
                <br /><br />
                <div className='containers'>
                <div class="container"> 
    <div class="line number1 index0 alt2"><code class="comment">//Program to print an arithmetic</code></div> <br/>
    <div class="line number2 index1 alt1"><code class="comment">// progression series</code></div> <br/>
    <div class="line number3 index2 alt2"><code class="library">#include &lt;iostream&gt;</code></div> <br/>
    <div class="line number4 index3 alt1"><code class="keywords">using </code> 
            <code class="keywords">namespace</code> <code class="plain">std;</code></div> <br/>

    <div class="line number6 index5 alt1"><code class="keywords">void</code> <code
            class="plain">printAP(</code><code class="function">int</code> <code class="plain">a, </code><code
            class="function">int</code> <code class="plain">d, </code><code class="function">int</code> <code
            class="plain">n)</code></div> <br/>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div> <br/>

    <div class="line number9 index8 alt2"><code class="comment">// Printing AP by simply adding d</code></div> <br/>
    <div class="line number10 index9 alt1"><code class="comment">// to previous term.</code></div> <br/>
    <div class="line number11 index10 alt2"><code class="function">int</code> <code class="plain">curr_term;</code>
    </div> <br/>
    <div class="line number12 index11 alt1"><code class="plain">curr_term=a;</code></div> <br/>
    <div class="line number13 index12 alt2"><code class="keywords">for</code> <code class="plain">(</code><code
            class="function">int</code> <code class="plain">i = 1; i &lt;= n; i++)</code></div> <br/>
    <div class="line number14 index13 alt1"><code
            class="plain">&#123;&nbsp;&nbsp; cout &lt;&lt; curr_term &lt;&lt; </code><code class="string">" "</code>
           
            <code class="plain">;</code></div> <br/>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
          <code  class="plain">curr_term =curr_term + d;</code></div> <br/>
    <div class="line number17 index16 alt2"><code class="plain">&#125;</code></div> 
    <div class="line number18 index17 alt1"><code class="plain">&#125;</code></div> 

    <div class="line number20 index19 alt1"><code class="comment">// Function code</code></div> <br/>
    <div class="line number21 index20 alt2"><code class="function">int</code> <code class="plain">main()</code></div> <br/>
    <div class="line number22 index21 alt1"><code class="plain">&#123;</code></div> <br/>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code class="comment">// starting number&nbsp;&nbsp;&nbsp;</code></div> <br/>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code  class="function">int</code> <code class="plain">a = 2;</code></div> <br/>

    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code   class="comment">// Common difference</code></div> <br/>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code   class="function">int</code> <code class="plain">d = 1;</code></div> <br/>

    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code  class="comment">// N th term to be find</code></div> <br/>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code  class="function">int</code> <code class="plain">n = 5;</code></div> <br/>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code   class="plain">printAP(a, d, n);</code></div> <br/>

    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>
        <code  class="keywords">return</code> <code class="plain">0;</code></div> <br/>
    <div class="line number35 index34 alt2"><code class="plain">&#125;</code></div> <br/>
</div> <br/>
                </div>
                <div className='output'>
                    <h3>Output: </h3>
                    <pre>{`2 3 4 5 6`}</pre>
                </div>
        </div>
    )
}

export default Ap
